import React from "react";
import PropTypes from "prop-types";

import { MyDraggable as Draggable } from "../../components/Core";
import HoverBar from "../../components/HoverBar";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container, Row, Col } from "reactstrap";

import { makeStyles } from "@material-ui/core/styles";
import { generateStyle, l, setOverLay } from "../../functions";
import Icon from "../../components/Icons";

import { connect } from "react-redux";
import isEqual from "lodash/isEqual";

const mapStateToProps = (state) => {
  return {
    currentLang: state.rootReducer.currentLang || 1,
    settings: state.rootReducer?.appearanceSettings || {},
  };
};

const useStyles = makeStyles((theme) => ({
  table: (props) => ({
    "& td,& th": {
      border: props.showBorderQD
        ? "1px solid " +
          (props.tableBorderColorQD ? props.tableBorderColorQD : "#000")
        : "none",
    },
    "& thead tr": {
      backgroundColor: setValue(props.tableHeadBgColorQD),
      color: setValue(props.tableHeadColorQD),
    },
    "& tbody tr:nth-child(2n)": {
      backgroundColor: setValue(props.tableEvenRowBgColorQD),
      color: setValue(props.tableEvenRowColorQD),
    },
    "& tbody tr:nth-child(2n+1)": {
      backgroundColor: setValue(props.tableOddRowBgColorQD),
      color: setValue(props.tableOddRowColorQD),
    },
  }),
}));

function setValue(value) {
  return value + importantValue(value);
}

function importantValue(value) {
  return value !== null ? " !important" : "";
}

function InitQty({ props }) {
  let { payload } = props;

  if (payload === null) payload = props.options.payload;

  const {
    showBorderQD,
    tableBorderColorQD,
    tableHeadColorQD,
    tableHeadBgColorQD,
    tableOddRowColorQD,
    tableEvenRowColorQD,
    tableOddRowBgColorQD,
    tableEvenRowBgColorQD,
  } = payload.datas || {};

  let labelQD = payload.datas["labelQD"] || "";

  if (payload.datas && payload.datas["labelQD_" + props.currentLang])
    labelQD = payload.datas["labelQD_" + props.currentLang];

  const cssSettings = generateStyle(payload, "container");
  const cssSettingsText = generateStyle(payload, "text", "body");

  const classes = useStyles({
    showBorderQD: showBorderQD,
    tableBorderColorQD: tableBorderColorQD,
    tableHeadColorQD: tableHeadColorQD,
    tableHeadBgColorQD: "#c5c4c4" || tableHeadBgColorQD,
    tableOddRowColorQD: tableOddRowColorQD,
    tableEvenRowColorQD: tableEvenRowColorQD,
    tableOddRowBgColorQD: tableOddRowBgColorQD,
    tableEvenRowBgColorQD: tableEvenRowBgColorQD,
  });

  return (
    <Container fluid={payload.fullContainer} style={cssSettings}>
      {setOverLay(payload)}
      <Row>
        <Col xs={12} className="fullcol" style={cssSettingsText}>
          {labelQD && <h4>{labelQD}</h4>}
          <table className={`qty-discounts ${classes.table}`}>
            <thead>
              <tr>
                <th>Quantity</th>
                <th>Price</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Buy 3</td>
                <td>SAVE 10% off each</td>
              </tr>
              <tr>
                <td>Buy 5</td>
                <td>SAVE $15.00 off each</td>
              </tr>
            </tbody>
          </table>
        </Col>
      </Row>
    </Container>
  );
}

class ProductQuantity extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  shouldComponentUpdate(nextProp, nextState) {
    if (
      !isEqual(this.props?.payload, nextProp?.payload) ||
      !isEqual(this.props?.settings, nextProp?.settings)
    ) {
      return true;
    }

    return false;
  }
  render() {
    const {
      dropzoneID,
      parentID,
      showBasicContent,
      showPreview,
      id,
      dropzoneProps,
      payload,
      options,
      ...rest
    } = this.props;

    if (showBasicContent) {
      return (
        <Draggable {...this.props} side={true}>
          <span className="dragger">
            {(Array.isArray(rest.icon) && (
              <FontAwesomeIcon icon={rest.icon} />
            )) || <Icon icon={rest.icon} />}
            <span>{l(rest.name)}</span>
          </span>
        </Draggable>
      );
    }

    if (showPreview) {
      return <InitQty props={this.props} />;
    }

    return (
      <Draggable {...this.props} minify={true}>
        <HoverBar
          datas={this.props}
          style={payload}
          parent={parentID}
          element={{ id, dropzoneID, parentID, payload }}
        />
        <InitQty props={this.props} />
      </Draggable>
    );
  }
}

ProductQuantity.propTypes = {
  id: PropTypes.string.isRequired,
  showBasicContent: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(ProductQuantity);
